import { render, staticRenderFns } from "./ProfileGuest.vue?vue&type=template&id=5baeaf0a"
import script from "./ProfileGuest.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileGuest.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileGuest.vue?vue&type=style&index=0&id=5baeaf0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports